// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/bom.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AirflowType,
  airflowTypeFromJSON,
  airflowTypeToJSON,
  BreakoutMode,
  CableType,
  cableTypeFromJSON,
  cableTypeToJSON,
  DeviceOrderableType,
  deviceOrderableTypeFromJSON,
  deviceOrderableTypeToJSON,
  NodeRole,
  nodeRoleFromJSON,
  nodeRoleToJSON,
  ServerPortGroup,
} from "./fabric";
import { GpuMode, NetworkPort, PortSummaryInfo, SlotMapConfiguration } from "./models";
import { BmcAuthType, bmcAuthTypeFromJSON, bmcAuthTypeToJSON } from "./server";
import { RackTray, SpeedMode } from "./types";

export const protobufPackage = "models";

/**
 * PortGroup defines a set of ports in a port group. Ports in a group
 * must have same port speed and cables.
 */
export interface PortGroup {
  ports: string[];
}

/** DeviceModel encapsulates device model info. */
export interface DeviceModel {
  /** ModelName defines a device model name or PID. */
  modelName: string;
  /** Name defines the user-defined name of device model. */
  name: string;
  /** Manufacturer defines the name of the device manufacturer. */
  manufacturer: string;
  /** MgmtPorts defines the number of physical management ports. */
  mgmtPorts: number;
  /** Ports defines the number of physical data ports. */
  dataPorts: number;
  /** Roles defines supported node roles for the device. */
  roles: NodeRole[];
  /** HostOnSpine indicates if hosts can be attached to the switch when it is a spine switch. */
  hostOnSpine: boolean;
  /** Description of the device model. */
  description: string;
  /** PortGroups defines adjacent SFP ports. All ports in a group must have same speed. */
  portGroups: PortGroup[];
  /** Breakouts defines supported port speed modes. */
  speeds: SpeedMode[];
  /** Breakouts defines supported breakout modes. */
  breakouts: BreakoutMode[];
  /** Ports defines default network ports of the device model. */
  ports: NetworkPort[];
  /** ServerPortGroups defines the properties of the server port groups. */
  serverPortGroups: ServerPortGroup[];
  /** Mapping of GPU numbers to slots and NIC slots */
  gpuNicSlotMap: SlotMapConfiguration[];
  /** GpuModes is a list of gpu configurations available for the device. */
  gpuModes: GpuMode[];
  /** MaxBreakoutPorts defines the maximum number of breakout-enabled ports for this model. */
  maxBreakoutPorts: number;
  /** PortSummary for each device based on speed and pluggable. */
  portSummary: PortSummaryInfo[];
  /** MaxInterfaces defines the maximum number of interfaces for the model when all ports are fully broken out. */
  maxInterfaces: number;
  /** AlternatePids refers to synonymous pids for a given device. */
  alternatePids: string[];
  /** A list of rack trays that are compatible with this device model. */
  rackTrays: RackTray[];
  /** OrderableType encodes a restricted-support qualifier for this device model. */
  orderableType: DeviceOrderableType;
  /** Management authentication schemes for this device model. */
  mgmtAuthSchemes: BmcAuthType[];
}

/** CableModel encapsulates cable model information. */
export interface CableModel {
  /** ModelName defines a cable model name or PID. */
  modelName: string;
  /** Speed defines cable speed (E.g. 100G). */
  speed: string;
  /** Connectors defines connector types (E.g. SFP+) of the cable. */
  connectors: string[];
  /** CableType defines the cable type. */
  cableType: CableType;
  /** CableLength defines length of the cable in meters. */
  cableLength: number;
  /** Plug defines cable plug type. */
  plug: string;
  /** Description defines a short description of the cable. */
  description: string;
  /** Breakout defines breakout type supported by the cable. */
  breakout: string;
  /** PartNumber defines vendor specific part number of the cable. */
  partNumber: string;
  /** Additional breakout configurations supported by cable. */
  alternateBreakouts: string[];
  /** Additional speeds supported by cable. */
  alternateSpeeds: string[];
}

/** PsuModel encapsulates psu model information. */
export interface PsuModel {
  /** ModelName defines a psu model name or PID. */
  modelName: string;
  /** Description defines a short description of the psu. */
  description: string;
  /** AirflowTypes defines the Airflow type. */
  airflowTypes: AirflowType[];
  /** isDefault indicates this is default psu model */
  isDefault: boolean;
}

/** DevicePsu encapsulates psud models for a device */
export interface DevicePSu {
  /** ModelName defines a device model name or PID. */
  modelName: string;
  /** psus defines psu models for the device model. */
  psus: PsuModel[];
}

function createBasePortGroup(): PortGroup {
  return { ports: [] };
}

export const PortGroup: MessageFns<PortGroup> = {
  encode(message: PortGroup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ports) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortGroup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ports.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortGroup {
    return { ports: globalThis.Array.isArray(object?.ports) ? object.ports.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: PortGroup): unknown {
    const obj: any = {};
    if (message.ports?.length) {
      obj.ports = message.ports;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortGroup>, I>>(base?: I): PortGroup {
    return PortGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortGroup>, I>>(object: I): PortGroup {
    const message = createBasePortGroup();
    message.ports = object.ports?.map((e) => e) || [];
    return message;
  },
};

function createBaseDeviceModel(): DeviceModel {
  return {
    modelName: "",
    name: "",
    manufacturer: "",
    mgmtPorts: 0,
    dataPorts: 0,
    roles: [],
    hostOnSpine: false,
    description: "",
    portGroups: [],
    speeds: [],
    breakouts: [],
    ports: [],
    serverPortGroups: [],
    gpuNicSlotMap: [],
    gpuModes: [],
    maxBreakoutPorts: 0,
    portSummary: [],
    maxInterfaces: 0,
    alternatePids: [],
    rackTrays: [],
    orderableType: 0,
    mgmtAuthSchemes: [],
  };
}

export const DeviceModel: MessageFns<DeviceModel> = {
  encode(message: DeviceModel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelName !== "") {
      writer.uint32(18).string(message.modelName);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.manufacturer !== "") {
      writer.uint32(34).string(message.manufacturer);
    }
    if (message.mgmtPorts !== 0) {
      writer.uint32(40).uint32(message.mgmtPorts);
    }
    if (message.dataPorts !== 0) {
      writer.uint32(48).uint32(message.dataPorts);
    }
    writer.uint32(58).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    if (message.hostOnSpine !== false) {
      writer.uint32(64).bool(message.hostOnSpine);
    }
    if (message.description !== "") {
      writer.uint32(74).string(message.description);
    }
    for (const v of message.portGroups) {
      PortGroup.encode(v!, writer.uint32(146).fork()).join();
    }
    for (const v of message.speeds) {
      SpeedMode.encode(v!, writer.uint32(154).fork()).join();
    }
    for (const v of message.breakouts) {
      BreakoutMode.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.ports) {
      NetworkPort.encode(v!, writer.uint32(170).fork()).join();
    }
    for (const v of message.serverPortGroups) {
      ServerPortGroup.encode(v!, writer.uint32(178).fork()).join();
    }
    for (const v of message.gpuNicSlotMap) {
      SlotMapConfiguration.encode(v!, writer.uint32(186).fork()).join();
    }
    for (const v of message.gpuModes) {
      GpuMode.encode(v!, writer.uint32(194).fork()).join();
    }
    if (message.maxBreakoutPorts !== 0) {
      writer.uint32(200).uint32(message.maxBreakoutPorts);
    }
    for (const v of message.portSummary) {
      PortSummaryInfo.encode(v!, writer.uint32(210).fork()).join();
    }
    if (message.maxInterfaces !== 0) {
      writer.uint32(216).uint32(message.maxInterfaces);
    }
    for (const v of message.alternatePids) {
      writer.uint32(226).string(v!);
    }
    for (const v of message.rackTrays) {
      RackTray.encode(v!, writer.uint32(234).fork()).join();
    }
    if (message.orderableType !== 0) {
      writer.uint32(240).int32(message.orderableType);
    }
    writer.uint32(250).fork();
    for (const v of message.mgmtAuthSchemes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceModel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.manufacturer = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mgmtPorts = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.dataPorts = reader.uint32();
          continue;
        }
        case 7: {
          if (tag === 56) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.hostOnSpine = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.portGroups.push(PortGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.speeds.push(SpeedMode.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.breakouts.push(BreakoutMode.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.ports.push(NetworkPort.decode(reader, reader.uint32()));
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.serverPortGroups.push(ServerPortGroup.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.gpuNicSlotMap.push(SlotMapConfiguration.decode(reader, reader.uint32()));
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.gpuModes.push(GpuMode.decode(reader, reader.uint32()));
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.maxBreakoutPorts = reader.uint32();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.portSummary.push(PortSummaryInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.maxInterfaces = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.alternatePids.push(reader.string());
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.rackTrays.push(RackTray.decode(reader, reader.uint32()));
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.orderableType = reader.int32() as any;
          continue;
        }
        case 31: {
          if (tag === 248) {
            message.mgmtAuthSchemes.push(reader.int32() as any);

            continue;
          }

          if (tag === 250) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.mgmtAuthSchemes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceModel {
    return {
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      manufacturer: isSet(object.manufacturer) ? globalThis.String(object.manufacturer) : "",
      mgmtPorts: isSet(object.mgmtPorts) ? globalThis.Number(object.mgmtPorts) : 0,
      dataPorts: isSet(object.dataPorts) ? globalThis.Number(object.dataPorts) : 0,
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => nodeRoleFromJSON(e)) : [],
      hostOnSpine: isSet(object.hostOnSpine) ? globalThis.Boolean(object.hostOnSpine) : false,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      portGroups: globalThis.Array.isArray(object?.portGroups)
        ? object.portGroups.map((e: any) => PortGroup.fromJSON(e))
        : [],
      speeds: globalThis.Array.isArray(object?.speeds) ? object.speeds.map((e: any) => SpeedMode.fromJSON(e)) : [],
      breakouts: globalThis.Array.isArray(object?.breakouts)
        ? object.breakouts.map((e: any) => BreakoutMode.fromJSON(e))
        : [],
      ports: globalThis.Array.isArray(object?.ports) ? object.ports.map((e: any) => NetworkPort.fromJSON(e)) : [],
      serverPortGroups: globalThis.Array.isArray(object?.serverPortGroups)
        ? object.serverPortGroups.map((e: any) => ServerPortGroup.fromJSON(e))
        : [],
      gpuNicSlotMap: globalThis.Array.isArray(object?.gpuNicSlotMap)
        ? object.gpuNicSlotMap.map((e: any) => SlotMapConfiguration.fromJSON(e))
        : [],
      gpuModes: globalThis.Array.isArray(object?.gpuModes) ? object.gpuModes.map((e: any) => GpuMode.fromJSON(e)) : [],
      maxBreakoutPorts: isSet(object.maxBreakoutPorts) ? globalThis.Number(object.maxBreakoutPorts) : 0,
      portSummary: globalThis.Array.isArray(object?.portSummary)
        ? object.portSummary.map((e: any) => PortSummaryInfo.fromJSON(e))
        : [],
      maxInterfaces: isSet(object.maxInterfaces) ? globalThis.Number(object.maxInterfaces) : 0,
      alternatePids: globalThis.Array.isArray(object?.alternatePids)
        ? object.alternatePids.map((e: any) => globalThis.String(e))
        : [],
      rackTrays: globalThis.Array.isArray(object?.rackTrays)
        ? object.rackTrays.map((e: any) => RackTray.fromJSON(e))
        : [],
      orderableType: isSet(object.orderableType) ? deviceOrderableTypeFromJSON(object.orderableType) : 0,
      mgmtAuthSchemes: globalThis.Array.isArray(object?.mgmtAuthSchemes)
        ? object.mgmtAuthSchemes.map((e: any) => bmcAuthTypeFromJSON(e))
        : [],
    };
  },

  toJSON(message: DeviceModel): unknown {
    const obj: any = {};
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.manufacturer !== "") {
      obj.manufacturer = message.manufacturer;
    }
    if (message.mgmtPorts !== 0) {
      obj.mgmtPorts = Math.round(message.mgmtPorts);
    }
    if (message.dataPorts !== 0) {
      obj.dataPorts = Math.round(message.dataPorts);
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => nodeRoleToJSON(e));
    }
    if (message.hostOnSpine !== false) {
      obj.hostOnSpine = message.hostOnSpine;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.portGroups?.length) {
      obj.portGroups = message.portGroups.map((e) => PortGroup.toJSON(e));
    }
    if (message.speeds?.length) {
      obj.speeds = message.speeds.map((e) => SpeedMode.toJSON(e));
    }
    if (message.breakouts?.length) {
      obj.breakouts = message.breakouts.map((e) => BreakoutMode.toJSON(e));
    }
    if (message.ports?.length) {
      obj.ports = message.ports.map((e) => NetworkPort.toJSON(e));
    }
    if (message.serverPortGroups?.length) {
      obj.serverPortGroups = message.serverPortGroups.map((e) => ServerPortGroup.toJSON(e));
    }
    if (message.gpuNicSlotMap?.length) {
      obj.gpuNicSlotMap = message.gpuNicSlotMap.map((e) => SlotMapConfiguration.toJSON(e));
    }
    if (message.gpuModes?.length) {
      obj.gpuModes = message.gpuModes.map((e) => GpuMode.toJSON(e));
    }
    if (message.maxBreakoutPorts !== 0) {
      obj.maxBreakoutPorts = Math.round(message.maxBreakoutPorts);
    }
    if (message.portSummary?.length) {
      obj.portSummary = message.portSummary.map((e) => PortSummaryInfo.toJSON(e));
    }
    if (message.maxInterfaces !== 0) {
      obj.maxInterfaces = Math.round(message.maxInterfaces);
    }
    if (message.alternatePids?.length) {
      obj.alternatePids = message.alternatePids;
    }
    if (message.rackTrays?.length) {
      obj.rackTrays = message.rackTrays.map((e) => RackTray.toJSON(e));
    }
    if (message.orderableType !== 0) {
      obj.orderableType = deviceOrderableTypeToJSON(message.orderableType);
    }
    if (message.mgmtAuthSchemes?.length) {
      obj.mgmtAuthSchemes = message.mgmtAuthSchemes.map((e) => bmcAuthTypeToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceModel>, I>>(base?: I): DeviceModel {
    return DeviceModel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceModel>, I>>(object: I): DeviceModel {
    const message = createBaseDeviceModel();
    message.modelName = object.modelName ?? "";
    message.name = object.name ?? "";
    message.manufacturer = object.manufacturer ?? "";
    message.mgmtPorts = object.mgmtPorts ?? 0;
    message.dataPorts = object.dataPorts ?? 0;
    message.roles = object.roles?.map((e) => e) || [];
    message.hostOnSpine = object.hostOnSpine ?? false;
    message.description = object.description ?? "";
    message.portGroups = object.portGroups?.map((e) => PortGroup.fromPartial(e)) || [];
    message.speeds = object.speeds?.map((e) => SpeedMode.fromPartial(e)) || [];
    message.breakouts = object.breakouts?.map((e) => BreakoutMode.fromPartial(e)) || [];
    message.ports = object.ports?.map((e) => NetworkPort.fromPartial(e)) || [];
    message.serverPortGroups = object.serverPortGroups?.map((e) => ServerPortGroup.fromPartial(e)) || [];
    message.gpuNicSlotMap = object.gpuNicSlotMap?.map((e) => SlotMapConfiguration.fromPartial(e)) || [];
    message.gpuModes = object.gpuModes?.map((e) => GpuMode.fromPartial(e)) || [];
    message.maxBreakoutPorts = object.maxBreakoutPorts ?? 0;
    message.portSummary = object.portSummary?.map((e) => PortSummaryInfo.fromPartial(e)) || [];
    message.maxInterfaces = object.maxInterfaces ?? 0;
    message.alternatePids = object.alternatePids?.map((e) => e) || [];
    message.rackTrays = object.rackTrays?.map((e) => RackTray.fromPartial(e)) || [];
    message.orderableType = object.orderableType ?? 0;
    message.mgmtAuthSchemes = object.mgmtAuthSchemes?.map((e) => e) || [];
    return message;
  },
};

function createBaseCableModel(): CableModel {
  return {
    modelName: "",
    speed: "",
    connectors: [],
    cableType: 0,
    cableLength: 0,
    plug: "",
    description: "",
    breakout: "",
    partNumber: "",
    alternateBreakouts: [],
    alternateSpeeds: [],
  };
}

export const CableModel: MessageFns<CableModel> = {
  encode(message: CableModel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelName !== "") {
      writer.uint32(10).string(message.modelName);
    }
    if (message.speed !== "") {
      writer.uint32(18).string(message.speed);
    }
    for (const v of message.connectors) {
      writer.uint32(26).string(v!);
    }
    if (message.cableType !== 0) {
      writer.uint32(32).int32(message.cableType);
    }
    if (message.cableLength !== 0) {
      writer.uint32(41).double(message.cableLength);
    }
    if (message.plug !== "") {
      writer.uint32(50).string(message.plug);
    }
    if (message.description !== "") {
      writer.uint32(58).string(message.description);
    }
    if (message.breakout !== "") {
      writer.uint32(66).string(message.breakout);
    }
    if (message.partNumber !== "") {
      writer.uint32(74).string(message.partNumber);
    }
    for (const v of message.alternateBreakouts) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.alternateSpeeds) {
      writer.uint32(90).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CableModel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCableModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.speed = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connectors.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.cableType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.cableLength = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.plug = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.breakout = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.partNumber = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.alternateBreakouts.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.alternateSpeeds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CableModel {
    return {
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      speed: isSet(object.speed) ? globalThis.String(object.speed) : "",
      connectors: globalThis.Array.isArray(object?.connectors)
        ? object.connectors.map((e: any) => globalThis.String(e))
        : [],
      cableType: isSet(object.cableType) ? cableTypeFromJSON(object.cableType) : 0,
      cableLength: isSet(object.cableLength) ? globalThis.Number(object.cableLength) : 0,
      plug: isSet(object.plug) ? globalThis.String(object.plug) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      breakout: isSet(object.breakout) ? globalThis.String(object.breakout) : "",
      partNumber: isSet(object.partNumber) ? globalThis.String(object.partNumber) : "",
      alternateBreakouts: globalThis.Array.isArray(object?.alternateBreakouts)
        ? object.alternateBreakouts.map((e: any) => globalThis.String(e))
        : [],
      alternateSpeeds: globalThis.Array.isArray(object?.alternateSpeeds)
        ? object.alternateSpeeds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: CableModel): unknown {
    const obj: any = {};
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.speed !== "") {
      obj.speed = message.speed;
    }
    if (message.connectors?.length) {
      obj.connectors = message.connectors;
    }
    if (message.cableType !== 0) {
      obj.cableType = cableTypeToJSON(message.cableType);
    }
    if (message.cableLength !== 0) {
      obj.cableLength = message.cableLength;
    }
    if (message.plug !== "") {
      obj.plug = message.plug;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.breakout !== "") {
      obj.breakout = message.breakout;
    }
    if (message.partNumber !== "") {
      obj.partNumber = message.partNumber;
    }
    if (message.alternateBreakouts?.length) {
      obj.alternateBreakouts = message.alternateBreakouts;
    }
    if (message.alternateSpeeds?.length) {
      obj.alternateSpeeds = message.alternateSpeeds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CableModel>, I>>(base?: I): CableModel {
    return CableModel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CableModel>, I>>(object: I): CableModel {
    const message = createBaseCableModel();
    message.modelName = object.modelName ?? "";
    message.speed = object.speed ?? "";
    message.connectors = object.connectors?.map((e) => e) || [];
    message.cableType = object.cableType ?? 0;
    message.cableLength = object.cableLength ?? 0;
    message.plug = object.plug ?? "";
    message.description = object.description ?? "";
    message.breakout = object.breakout ?? "";
    message.partNumber = object.partNumber ?? "";
    message.alternateBreakouts = object.alternateBreakouts?.map((e) => e) || [];
    message.alternateSpeeds = object.alternateSpeeds?.map((e) => e) || [];
    return message;
  },
};

function createBasePsuModel(): PsuModel {
  return { modelName: "", description: "", airflowTypes: [], isDefault: false };
}

export const PsuModel: MessageFns<PsuModel> = {
  encode(message: PsuModel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelName !== "") {
      writer.uint32(10).string(message.modelName);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    writer.uint32(26).fork();
    for (const v of message.airflowTypes) {
      writer.int32(v);
    }
    writer.join();
    if (message.isDefault !== false) {
      writer.uint32(32).bool(message.isDefault);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PsuModel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePsuModel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.airflowTypes.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.airflowTypes.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PsuModel {
    return {
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      airflowTypes: globalThis.Array.isArray(object?.airflowTypes)
        ? object.airflowTypes.map((e: any) => airflowTypeFromJSON(e))
        : [],
      isDefault: isSet(object.isDefault) ? globalThis.Boolean(object.isDefault) : false,
    };
  },

  toJSON(message: PsuModel): unknown {
    const obj: any = {};
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.airflowTypes?.length) {
      obj.airflowTypes = message.airflowTypes.map((e) => airflowTypeToJSON(e));
    }
    if (message.isDefault !== false) {
      obj.isDefault = message.isDefault;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PsuModel>, I>>(base?: I): PsuModel {
    return PsuModel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PsuModel>, I>>(object: I): PsuModel {
    const message = createBasePsuModel();
    message.modelName = object.modelName ?? "";
    message.description = object.description ?? "";
    message.airflowTypes = object.airflowTypes?.map((e) => e) || [];
    message.isDefault = object.isDefault ?? false;
    return message;
  },
};

function createBaseDevicePSu(): DevicePSu {
  return { modelName: "", psus: [] };
}

export const DevicePSu: MessageFns<DevicePSu> = {
  encode(message: DevicePSu, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.modelName !== "") {
      writer.uint32(10).string(message.modelName);
    }
    for (const v of message.psus) {
      PsuModel.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DevicePSu {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevicePSu();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.psus.push(PsuModel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DevicePSu {
    return {
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      psus: globalThis.Array.isArray(object?.psus) ? object.psus.map((e: any) => PsuModel.fromJSON(e)) : [],
    };
  },

  toJSON(message: DevicePSu): unknown {
    const obj: any = {};
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.psus?.length) {
      obj.psus = message.psus.map((e) => PsuModel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DevicePSu>, I>>(base?: I): DevicePSu {
    return DevicePSu.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DevicePSu>, I>>(object: I): DevicePSu {
    const message = createBaseDevicePSu();
    message.modelName = object.modelName ?? "";
    message.psus = object.psus?.map((e) => PsuModel.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
